import { useEffect } from 'react';
import { Form, Typography, Row, Col, Input, Switch } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// import { WarningOutlined } from '@ant-design/icons';
import {
  BASE_RATE_MIN_AMOUNT,
  BASE_RATE_MAX_AMOUNT,
  BASE_RATE_TYPE,
  BASE_RATE_VALUE,
  BASE_RATE_MODE_CONSTANT,
  BASE_RATE_SLAB_ENABLE_KEY,
  BASE_RATE_SLAB_KEY,
  BASE_RATE_ENABLE,
  BASE_RATE_DISABLE,
  RUPEE_SIGN,
  PERCENTAGE_SIGN,
  PERCENTAGE,
  INFINITY_SIGN,
  SettingsFormItemHorizontal
} from './const';

const InputWrapper = styled(Input)`
  padding: 8px;
`;
function PartnerBaseRateConfigurationForm({ productKey, mode, baseRateForm }) {
  const getBaseRateModeValue = (key) => BASE_RATE_MODE_CONSTANT[key]?.value || key;

  const checkedMode = baseRateForm.getFieldValue([productKey, mode, BASE_RATE_SLAB_ENABLE_KEY])
    ? BASE_RATE_ENABLE
    : BASE_RATE_DISABLE;
  const checkedModeSlab = baseRateForm.getFieldValue([productKey, mode, BASE_RATE_SLAB_KEY]);
  const modeButtonKey = `${checkedMode} ${getBaseRateModeValue(mode)}`;

  useEffect(() => {
    const slabs = baseRateForm?.getFieldValue([productKey, mode, BASE_RATE_SLAB_KEY]) || [];
    const modeEnable = baseRateForm?.getFieldValue([productKey, mode, BASE_RATE_SLAB_ENABLE_KEY]);
    if (modeEnable && slabs?.length === 0) {
      baseRateForm?.setFieldValue(
        [productKey, mode, BASE_RATE_SLAB_KEY],
        [{ min_amount: 0, max_amount: null, base_rate_type: 'PERCENTAGE', base_rate_value: 0 }]
      );
    }
  }, [baseRateForm]);

  return (
    <>
      <SettingsFormItemHorizontal
        name={[productKey, mode, 'is_enable']}
        key={[productKey, mode, 'is_enable']}
        label={<Typography.Title level={5}>{modeButtonKey}</Typography.Title>}
        valuePropName="checked"
      >
        <Switch />
      </SettingsFormItemHorizontal>
      <Typography.Title level={5}>Base Rate</Typography.Title>
      <div
        style={{
          cursor: 'not-allowed',
          opacity: 0.8
        }}
      >
        <Form.List name={[productKey, mode, 'slab']}>
          {(fields) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      label="Min Amount"
                      name={[name, BASE_RATE_MIN_AMOUNT]}
                      key={[name, BASE_RATE_MIN_AMOUNT]}
                      {...restField}
                    >
                      <InputWrapper prefix={RUPEE_SIGN} style={{ width: '100%' }} disabled />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Max Amount"
                      name={
                        checkedModeSlab.at(name).max_amount === 'Infinity'
                          ? ''
                          : [name, BASE_RATE_MAX_AMOUNT]
                      }
                      key={[name, BASE_RATE_MAX_AMOUNT]}
                      {...restField}
                    >
                      <InputWrapper
                        prefix={
                          checkedModeSlab.at(name).max_amount === 'Infinity'
                            ? INFINITY_SIGN
                            : RUPEE_SIGN
                        }
                        style={{ width: '100%' }}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Type"
                      name={[name, BASE_RATE_TYPE]}
                      key={[name, BASE_RATE_TYPE]}
                      {...restField}
                    >
                      <InputWrapper
                        placeholder="Please select a type"
                        disabled
                        key={[name, BASE_RATE_TYPE]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Charge"
                      name={[name, BASE_RATE_VALUE]}
                      key={[name, BASE_RATE_VALUE]}
                      {...restField}
                    >
                      <InputWrapper
                        prefix={
                          checkedModeSlab.length > 0 &&
                          checkedModeSlab.at(name) &&
                          checkedModeSlab.at(name).base_rate_type === PERCENTAGE
                            ? PERCENTAGE_SIGN
                            : RUPEE_SIGN
                        }
                        style={{ width: '100%' }}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
            </>
          )}
        </Form.List>
      </div>
    </>
  );
}

PartnerBaseRateConfigurationForm.propTypes = {
  productKey: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  baseRateForm: PropTypes.func.isRequired
};

export default PartnerBaseRateConfigurationForm;
